import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';
import TeamBioModal from '../../TeamBioModal';
import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .TeamCard {
    width: 300px;
    margin: 0 15px 30px 15px;
    padding: 15px;
    text-align: center;
    background-color: ${colors.white};
    border: 1px solid ${colors.neutralLight};
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.05);
  }
  .TeamCard_name {
    font-size: 21px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 1;
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 60px;
      height: 3px;
      background-color: ${colors.brand2};
      margin: 15px auto;
    }
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .TeamCard_title {
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 1px;
    line-height: 1;
    text-transform: uppercase;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  .TeamCard_position {
    display: block;
    font-size: 0.5em;
    letter-spacing: 0.071429em;
    text-transform: uppercase;
    padding-top: 10px;

  }
  .TeamCard_links {
    display: block;
  }
  .TeamCard_link {
    display: block;
    transition: none;
    padding: 2px;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.357143;
    letter-spacing: 0.071429em;
    color: black;
    img {
      display: inline-block;
      margin-right: 6px;
    }
    @media (min-width: 992px) {
      font-size: 14px;
    }
  }
  .TeamCard_link-email {
    margin-bottom: 9px;
    text-indent: -31px;
    margin-left: 31px;
    img {
      width: 17px;
    }
  }
  .TeamCard_link-phone {
    img {
      width: 16px;
    }
  }
  .TeamCard_content {
    padding:15px;
  }
  .TeamCard_image {
    max-width: 100%;
  }
`;


function Team({ content }) {
  return (
    <section className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} />
      }
      <div className="container">
        <div className="row justify-content-center">
          {
            get(content, '[0]team_members' || []).map(item => {
              return (
                <div className="TeamCard" key={item.name}>
                  {
                    get(item, 'image.contentUrl') &&
                    <Image
                      src={get(item, 'image.contentUrl')}
                      alt={get(item, 'image.name', get(item, 'image.caption', ''))}
                      className="TeamCard_image"
                      width={600}
                      height={600}
                      exact
                    />
                  }
                  <div className="TeamCard_content">
                    {
                      get(item, 'name') &&
                      <h4 className="TeamCard_name">{get(item, 'name')}</h4>
                    }
                    {
                      get(item, 'title') &&
                      <h4 className="TeamCard_title">{get(item, 'title')}</h4>
                    }
                    {
                      (get(item, 'email') || get(item, 'phone')) &&
                      <div className="TeamCard_links">
                        {
                          get(item, 'email') &&
                          <a className="TeamCard_link TeamCard_link-email" href={`mailto:${get(item, 'email')}`}>
                            <img src="/images/icon-email-brand.svg" alt="email icon" />
                            Email
                          </a>
                        }
                        {
                          get(item, 'phone') &&
                          <a className="TeamCard_link TeamCard_link-phone" href={`tel:${get(item, 'phone').replace(/[^0-9]/g, '')}`}>
                            <img src="/images/icon-phone-brand.svg" alt="phone icon" />{get(item, 'phone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}
                          </a>
                        }
                      </div>
                    }
                    {
                      get(item, 'bio') &&
                      <TeamBioModal item={item}>
                        <div className="btn btn-small btn-hollow-brand3 mt-3">Read Bio</div>
                      </TeamBioModal>
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </section>
  );
}

Team.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Team;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/Team.section.js